export const apiConstant = {
    addCloneHeaderColumn: '/workbench/soa/add-or-clone-column',
    applySOAActivities:
        '/workbench/soa/update-selected-standard-soa-activities',
    applySOATemplates: '/workbench/soa/create-soa-by-template-id',
    checkAuthentication: '/workbench/ecb/check-authorization',
    cleanupSoaFootnotes: '/workbench/soa/cleanup-soa-footnote-comment',
    deleteFavoriteTemplate: '/workbench/soa/delete-favorite-soa',
    deleteProject: '/project/delete-project',
    deletePromptInstructionLibrary:
        '/workbench/ecb/delete-prompt-instruction-library',
    deleteSoaFootnotes: '/workbench/soa/delete-footnote-and-comments',
    deleteSoaView: '/workbench/soa/delete-soa-view',
    exportHeatmap: '/workbench/ecb/download-heatmap',
    exportSoa: '/workbench/soa/export-soa',
    exportSoaPPT: '/workbench/soa/export-dosing-schema',
    exportSoaViews: '/workbench/soa/export-soa-views',
    fetchAllPromptInstruction: '/workbench/ecb/fetch-all-prompt-instruction',
    fetchDocSection: '/workbench/ecb/fetch-doc-section-info-from-apd',
    fetchGlobalFootnotes: '/workbench/soa/fetch-global-footnotes',
    fetchDraft: '/workbench/ecb/fetch-ec-draft',
    fetchProjectAuditLog: '/project/fetch-project-audit-log',
    fetchProjectEC: '/project/fetch-project-detail-by-id',
    fetchProjectFilterValues: '/common/fetch-project-filter-parameter-values',
    fetchProjectList: '/project/fetch-project-detail',
    fetchPromptInstruction: '/workbench/ecb/fetch-prompt-instruction',
    fetchSILStudyID: '/workbench/ecb/fetch-sil-study-id',
    fetchSOAActivities: '/workbench/soa/fetch-all-standard-soa-activities',
    fetchSOAFilterAndData: '/workbench/soa/fetch-soa-filter-and-data-by-id',
    fetchSoaViews: '/workbench/soa/fetch-soa-views',
    fetchSOATemplates: '/workbench/soa/fetch-soa-templates',
    fetchStudyDetailFromSIL: '/workbench/ecb/fetch-study-detail-by-study-id',
    fetchStudyInfoSIL: '/workbench/ecb/fetch-study-info-sil',
    fetchUploadPDF: '/workbench/ecb/fetch-uploaded-docs-info-from-apd',
    fetchUsersList: '/common/fetch-user-list',
    fetchWorkbenchStudyInput: '/workbench/ecb/fetch-ec-workbench-input',
    generateDraft: '/workbench/ecb/generate-draft',
    generateHeatmap: '/workbench/ecb/generate-heatmap',
    inclusivityDeleteCriteria:
        '/workbench/ecb/inclusivity_research/delete-criteria',
    inclusivityRearrangeCriteria:
        '/workbench/ecb/inclusivity_research/rearrange-criteria',
    inclusivitySaveCriteria:
        '/workbench/ecb/inclusivity_research/save-ie-criteria',
    inclusivitySaveRationale:
        '/workbench/ecb/inclusivity_research/save-criteria-rationale',
    inclusivityUpdateCriteriaRecommendationDecision:
        '/workbench/ecb/inclusivity_research/update-criteria-decision',
    regenerateDraft: '/workbench/ecb/regenerate-draft',
    regenerateHeatmap: '/workbench/ecb/regenerate-heatmap',
    regenerateHeatmapOnReassignment:
        '/workbench/ecb/regenerate-heatmap-on-reassignment',
    reorderSoaFootnotes: '/workbench/soa/reorder-footnotes',
    resetECWorkbenchPromptInstruction:
        '/workbench/ecb/reset-ec-workbench-prompt-instruction',
    resetSoaTable: '/workbench/soa/reset-soa-table',
    resolveSOAComment: '/workbench/soa/resolve-comment',
    deleteECBCommentById: '/workbench/ecb/delete-comment-by-id',
    editECBComment: '/workbench/ecb/edit-comment',
    saveECBComment: '/workbench/ecb/save-comment',
    resolveECBComment: '/workbench/ecb/resolve-comment',
    restoreOriginalDraft: '/workbench/ecb/restore-original-draft',
    restoreOriginalHeatmap: '/workbench/ecb/restore-original-heatmap',
    saveAsFav: '/workbench/soa/add-as-favorites',
    saveECDraft: '/workbench/ecb/export-ec-draft-to-designer',
    saveHeatmap: '/workbench/ecb/save-ec-heatmap',
    saveProject: '/project/save-project',
    savePromptInstruction: '/workbench/ecb/save-ec-prompt-instruction',
    savePromptInstructionLibrary:
        '/workbench/ecb/save-prompt-instruction-library',
    deleteSOACommentById: '/workbench/soa/delete-comment-by-id',
    editSOAComment: '/workbench/soa/edit-comment',
    saveSOAComment: '/workbench/soa/save-comment',
    saveSoaFootnote: '/workbench/soa/save-footnote',
    saveSoaViews: '/workbench/soa/save-soa-views',
    switchTableType: '/workbench/soa/switch-table-type',
    saveUser: '/project/save-user',
    saveWorkbenchStudyInput: '/workbench/ecb/save-ec-workbench-input',
    updateInstanceTitle: '/common/update-instance-title',
    updateSoaEntity: '/workbench/soa/update-soa-entity',
    updateSoaFootnote: '/workbench/soa/update-footnote',
    rearrangeSOAViews: '/workbench/soa/rearrange-soa-views',
    addProjectUser: '/common/add-project-user',
    deleteProjectUserRole: '/common/delete-project-user-role',
    updateProjectUserRole: '/common/update-project-user-role',
    fetchUserRolePermissions: '/common/fetch-user-role-permissions',
    fetchCollaborators: '/common/fetch-collaborators',
    updateNotificationPreference: '/common/update-notification-preference',

    historyList: '/workbench/soa/fetch-soa-history', // + /{soa_id}/history
    historyState: '/workbench/soa/fetch-soa-history-state', // + /{soa_id}/history/{history_id}/state
    historyRevert: '/workbench/soa/revert-soa-history', // + /{soa_id}/history/{history_id}/revert
    historyRevertUndo: '/workbench/soa/selective-undo', // + /{soa_id}/history/{history_id}/revert
    historyRevertRedo: '/workbench/soa/selective-redo', // + /{soa_id}/history/{history_id}/revert
    historyTag: '/workbench/soa/tag-soa-history', // + /{soa_id}/history/{history_id}/tag
    uploadPdf: '/workbench/soa/import-pdf/upload',
    analyzePdf: '/workbench/soa/import-pdf/analyze',
    extractPdf: '/workbench/soa/import-pdf/extract',
    ingestPdfResults: '/workbench/soa/import-pdf/ingest-results',
};
